import { useQuery } from "react-query";
import { GET_CURRENT_COMMUNICATION, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getCurrentCommunication } from "api/clinicalManagement";
import extractRecords from "../utils/extractRecords";

const useGetCurrentCommunication = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_CURRENT_COMMUNICATION, clientId],
    () => getCurrentCommunication(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  const records = extractRecords(data);
  const currentCommunication = records.length > 0 ? records[0] : null;

  return {
    currentCommunication,
    currentCommunicationLoading: isLoading,
    refetchCurrentCommunication: refetch,
    ...rest,
  };
};

export default useGetCurrentCommunication;
